import { useLocation } from 'react-router-dom';

import { decodeQueryParams } from 'utils/queryParams';

export function useQueryParams<T = Record<string, unknown>>() {
  return decodeQueryParams<T>(useLocation().search);
}
